import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ResourceService } from './resource.service';
import { RecordChange } from '@model';

@Injectable()
export class HistoryService {
  constructor(private historyResourceService: ResourceService<RecordChange>) {}

  getChangeHistory$(objectId: string): Observable<RecordChange[]> {
    return this.historyResourceService.getPaginated(
      `history/entity/${objectId}`,
    );
  }

  getFirstChange$(objectId: string): Observable<RecordChange> {
    return this.historyResourceService.get(`history/entity/${objectId}/first`);
  }

  getLastChange$(objectId: string): Observable<RecordChange> {
    return this.historyResourceService.get(`history/entity/${objectId}/last`);
  }
}
